konnyScript(function($){
    
    var swiper = new Swiper("#outgif_swiper_slide1", {
        slidesPerView:1,
        slidesPerGroup:1,
        centeredSlides:true,
        loop:true,
        effect:'fade',
        speed:0,
        autoplay:{
            delay:700,
            disableOnInteraction:false,
        },
        scrollbar: {
            el: '#outgif_swiper_slide1 .swiper-scrollbar',
        },
        pagination: {
            el: '#outgif_swiper_slide1 .swiper-pagination',
        },
        navigation: {
            nextEl: '#outgif_swiper_slide1 .swiper-button-next',
            prevEl: '#outgif_swiper_slide1 .swiper-button-prev',
        },
    });
    
    var swiper = new Swiper("#outgif_swiper_slide2", {
        slidesPerView:1,
        slidesPerGroup:1,
        centeredSlides:true,
        loop:true,
        effect:'fade',
        speed:0,
        autoplay:{
            delay:700,
            disableOnInteraction:false,
        },
        scrollbar: {
            el: '#outgif_swiper_slide2 .swiper-scrollbar',
        },
        pagination: {
            el: '#outgif_swiper_slide2 .swiper-pagination',
        },
        navigation: {
            nextEl: '#outgif_swiper_slide2 .swiper-button-next',
            prevEl: '#outgif_swiper_slide2 .swiper-button-prev',
        },
    });
  
    var swiper = new Swiper("#outgif_swiper_slide3", {
        slidesPerView:1,
        slidesPerGroup:1,
        centeredSlides:true,
        loop:true,
        effect:'fade',
        speed:0,
        autoplay:{
            delay:700,
            disableOnInteraction:false,
        },
        scrollbar: {
            el: '#outgif_swiper_slide3 .swiper-scrollbar',
        },
        pagination: {
            el: '#outgif_swiper_slide3 .swiper-pagination',
        },
        navigation: {
            nextEl: '#outgif_swiper_slide3 .swiper-button-next',
            prevEl: '#outgif_swiper_slide3 .swiper-button-prev',
        },
    });
  
    var swiper = new Swiper("#outgif_swiper_slide4", {
        slidesPerView:1,
        slidesPerGroup:1,
        centeredSlides:true,
        loop:true,
        effect:'fade',
        speed:0,
        autoplay:{
            delay:700,
            disableOnInteraction:false,
        },
        scrollbar: {
            el: '#outgif_swiper_slide4 .swiper-scrollbar',
        },
        pagination: {
            el: '#outgif_swiper_slide4 .swiper-pagination',
        },
        navigation: {
            nextEl: '#outgif_swiper_slide4 .swiper-button-next',
            prevEl: '#outgif_swiper_slide4 .swiper-button-prev',
        },
    });
  
    var swiper = new Swiper("#outgif_swiper_slide5", {
        slidesPerView:1,
        slidesPerGroup:1,
        centeredSlides:true,
        loop:true,
        effect:'fade',
        speed:0,
        autoplay:{
            delay:700,
            disableOnInteraction:false,
        },
        scrollbar: {
            el: '#outgif_swiper_slide5 .swiper-scrollbar',
        },
        pagination: {
            el: '#outgif_swiper_slide5 .swiper-pagination',
        },
        navigation: {
            nextEl: '#outgif_swiper_slide5 .swiper-button-next',
            prevEl: '#outgif_swiper_slide5 .swiper-button-prev',
        },
    });
    
    var swiper = new Swiper("#dec_swiper_slide1", {
        slidesPerView:2.05,
        slidesPerGroup:1,
        spaceBetween:15,
        centeredSlides:false,
        observer:true,
        observeParents:true,
        //loop:true,
        pagination:true,
        scrollbar: {
            el: '#dec_swiper_slide1 .swiper-scrollbar',
        },
        pagination: {
            el: '#dec_swiper_slide1 .swiper-pagination',
        },
        navigation: {
            nextEl: '#dec_swiper_slide1 .swiper-button-next',
            prevEl: '#dec_swiper_slide1 .swiper-button-prev',
        },
    });
    
    var swiper = new Swiper("#dec_swiper_slide2", {
        slidesPerView:2.05,
        slidesPerGroup:1,
        spaceBetween:15,
        centeredSlides:false,
        observer:true,
        observeParents:true,
        //loop:true,
        pagination:true,
        scrollbar: {
            el: '#dec_swiper_slide2 .swiper-scrollbar',
        },
        pagination: {
            el: '#dec_swiper_slide2 .swiper-pagination',
        },
        navigation: {
            nextEl: '#dec_swiper_slide2 .swiper-button-next',
            prevEl: '#dec_swiper_slide2 .swiper-button-prev',
        },
    });
    
    var swiper = new Swiper("#dec_swiper_slide3", {
        slidesPerView:2.05,
        slidesPerGroup:1,
        spaceBetween:15,
        centeredSlides:false,
        observer:true,
        observeParents:true,
        //loop:true,
        pagination:true,
        scrollbar: {
            el: '#dec_swiper_slide3 .swiper-scrollbar',
        },
        pagination: {
            el: '#dec_swiper_slide3 .swiper-pagination',
        },
        navigation: {
            nextEl: '#dec_swiper_slide3 .swiper-button-next',
            prevEl: '#dec_swiper_slide3 .swiper-button-prev',
        },
    });
    
    var swiper = new Swiper("#dec_swiper_slide4", {
        slidesPerView:2.05,
        slidesPerGroup:1,
        spaceBetween:15,
        centeredSlides:false,
        observer:true,
        observeParents:true,
        //loop:true,
        pagination:true,
        scrollbar: {
            el: '#dec_swiper_slide4 .swiper-scrollbar',
        },
        pagination: {
            el: '#dec_swiper_slide4 .swiper-pagination',
        },
        navigation: {
            nextEl: '#dec_swiper_slide4 .swiper-button-next',
            prevEl: '#dec_swiper_slide4 .swiper-button-prev',
        },
    });
});